<template>
  <div 
    :data="backgroundColor"
    class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
    @mouseenter="$sidebar.onMouseEnter()"
    @mouseleave="$sidebar.onMouseLeave()">
    <div
      ref="sidebarScrollArea"
      class="scrollbar-inner">
      <div class="sidenav-header d-flex align-items-center">
        <a 
          class="navbar-brand" 
          href="#">
          <img 
            src="/img/brand/logo_color.png" 
            class="navbar-brand-img" 
            alt="Logo">
        </a>
        <div class="ml-auto">
          <!-- Sidenav toggler -->
          <div 
            :class="{'active': !$sidebar.isMinimized }"
            class="sidenav-toggler d-none d-xl-block"
            @click="minimizeSidebar">
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"/>
              <i class="sidenav-toggler-line"/>
              <i class="sidenav-toggler-line"/>
            </div>
          </div>
        </div>
      </div>
      <slot/>
      <div class="navbar-inner">
        <ul class="navbar-nav">
          <slot name="links">
            <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link"
            >
              <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                :link="subLink"
              />
            </sidebar-item>
          </slot>
        </ul>
        <slot name="links-after"/>
      </div>
    </div>
    <div class="sidenav-footer">
      <slot name="footer"/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Sidebar',
  props: {
    title: {
      type: String,
      default: 'Creative Tim',
      description: 'Sidebar title'
    },
    shortTitle: {
      type: String,
      default: 'CT',
      description: 'Sidebar short title'
    },
    logo: {
      type: String,
      default: 'https://demos.creative-tim.com/vue-argon-dashboard-pro/img/brand/green.png',
      description: 'Sidebar app logo'
    },
    backgroundColor: {
      type: String,
      default: 'vue',
      validator: value => {
        let acceptedValues = [
          '',
          'vue',
          'blue',
          'green',
          'orange',
          'red',
          'primary'
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        'Sidebar background color (vue|blue|green|orange|red|primary)'
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these."
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  mounted() {
    this.$sidebar.isMinimized = this.$sidebar.breakpoint < window.innerWidth
    this.minimizeSidebar()
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
};
</script>
<style lang="scss">
.sidenav.navbar-vertical.navbar-expand-xs {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100vh;
}

.sidenav.navbar-vertical > .scrollbar-inner {
  flex: 1 1 auto;
  min-height: 0;
  height: auto;
  overflow-y: auto;
}

.sidenav-footer {
  flex-shrink: 0;
  border-top: 1px solid #e9ecef;
  padding: 0.75rem 1.25rem 1rem;
  background: #fff;
}

.sidenav-footer .sidebar-logout {
  display: flex;
  align-items: center;
  width: 100%;
  border: 0;
  background: transparent;
  color: #f5365c;
  font-weight: 600;
  padding: 0.4rem 0;
  cursor: pointer;
}

.sidenav-footer .sidebar-logout i {
  margin-right: 0.75rem;
  font-size: 1.1rem;
}

.g-sidenav-hidden .sidenav-footer,
.g-sidenav-hide .sidenav-footer {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.g-sidenav-hidden .sidenav-footer .sidebar-logout,
.g-sidenav-hide .sidenav-footer .sidebar-logout {
  justify-content: center;
}

.g-sidenav-hidden .sidenav-footer .sidebar-logout i,
.g-sidenav-hide .sidenav-footer .sidebar-logout i {
  margin-right: 0;
}
</style>
